export class ListThreatHuntingScanRequestsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "scanRequests",
            "baseName": "scanRequests",
            "type": "Array<ThreatHuntingScanRequest>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListThreatHuntingScanRequestsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
